import {
  BLACK_LABEL,
  BLUE_LABEL,
  CHOCOLATE_LABEL,
  CORK_LABEL,
  CURSIVE,
  CURSIVE_LABEL,
  GOLD_LABEL,
  GREEN_LABEL,
  LEATHER_LINING_FIRST_LABEL,
  LEATHER_LINING_SECOND_LABEL,
  LEMON_YELLOW_LABEL,
  LIGHT_GOLD_LABEL,
  LIGHT_SILVER_LABEL,
  LITTLE_LABEL,
  NAVY_LABEL,
  NONE_LABEL,
  ORANGE_LABEL,
  PINK_LABEL,
  PINKY_LABEL,
  PINKY_SIDE_BACK_LABEL,
  PURPLE_LABEL,
  RED_LABEL,
  SANS_SERIF,
  SANS_SERIF_LABEL,
  SERIF,
  SERIF_LABEL,
  SILVER_LABEL,
  SKY_BLUE_LABEL,
  THUMB_LABEL,
  WHITE_LABEL,
  YELLOW_LABEL
} from '../../constants/embroidery'

export const typeFaceEnAllObjs = [
  { label: SANS_SERIF_LABEL, value: SANS_SERIF.value, imageUrl: SANS_SERIF.imageUrl }, //ゴシック体
  { label: CURSIVE_LABEL, value: CURSIVE.value, imageUrl: CURSIVE.imageUrl }, // 筆記体
  { label: SERIF_LABEL, value: SERIF.value, imageUrl: SERIF.imageUrl } // 明朝体
]
export const positionEnObjs = [
  { label: THUMB_LABEL, value: 'thumbFinger' },
  { label: PINKY_LABEL, value: 'childFinger' },
  { label: PINKY_SIDE_BACK_LABEL, value: 'pinkyFingerSideBack' },
  { label: LEATHER_LINING_FIRST_LABEL, value: 'leatherLiningFirst' },
  { label: LEATHER_LINING_SECOND_LABEL, value: 'leatherLiningSecond' }
]

export const colorEnObjs = [
  { label: GOLD_LABEL, value: 'gold', color: '#D9A948' },
  { label: SILVER_LABEL, value: 'silver', color: '#A7A8A7' },
  { label: LIGHT_GOLD_LABEL, value: 'lightGold', color: '#D7B070' },
  { label: LIGHT_SILVER_LABEL, value: 'lightSilver', color: '#DFDAD4' },
  { label: CORK_LABEL, value: 'cork', color: '#A18555' },
  { label: CHOCOLATE_LABEL, value: 'chocolate', color: '#6F4A35' },
  { label: YELLOW_LABEL, value: 'yellow', color: '#F3CD54' },
  { label: LEMON_YELLOW_LABEL, value: 'lemonYellow', color: '#FFF059' },
  { label: ORANGE_LABEL, value: 'orange', color: '#CF7D43' },
  { label: RED_LABEL, value: 'red', color: '#A03D38' },
  { label: PINK_LABEL, value: 'pink', color: '#E57780' },
  { label: PURPLE_LABEL, value: 'purple', color: '#8200C6' },
  { label: GREEN_LABEL, value: 'green', color: '#719B4F' },
  { label: SKY_BLUE_LABEL, value: 'skyBlue', color: '#0096C9' },
  { label: BLUE_LABEL, value: 'royalBlue', color: '#305173' },
  { label: NAVY_LABEL, value: 'navy', color: '#2C3F67' },
  { label: BLACK_LABEL, value: 'black', color: '#1A1919' },
  { label: WHITE_LABEL, value: 'white', color: '#F6F3F0' }
]

export const shadowEdgeColorEnObjs = [{ label: NONE_LABEL, value: 'none' }, ...colorEnObjs]

export const en2JaEmbroideryPartsTranslates = [
  { en: NONE_LABEL, japanese: '不要' },
  { en: GOLD_LABEL, japanese: 'ゴールド' },
  { en: SILVER_LABEL, japanese: 'シルバー' },
  { en: LIGHT_GOLD_LABEL, japanese: 'ライトゴールド' },
  { en: LIGHT_SILVER_LABEL, japanese: 'ライトシルバー' },
  { en: CORK_LABEL, japanese: 'コルク' },
  { en: CHOCOLATE_LABEL, japanese: 'チョコレート' },
  { en: YELLOW_LABEL, japanese: 'イエロー' },
  { en: LEMON_YELLOW_LABEL, japanese: 'レモンイエロー' },
  { en: ORANGE_LABEL, japanese: 'オレンジ' },
  { en: RED_LABEL, japanese: 'レッド' },
  { en: PINK_LABEL, japanese: 'ピンク' },
  { en: PURPLE_LABEL, japanese: 'パープル' },
  { en: GREEN_LABEL, japanese: 'グリーン' },
  { en: SKY_BLUE_LABEL, japanese: 'スカイブルー' },
  { en: BLUE_LABEL, japanese: 'ブルー' },
  { en: NAVY_LABEL, japanese: 'ネイビー' },
  { en: BLACK_LABEL, japanese: 'ブラック' },
  { en: WHITE_LABEL, japanese: 'ホワイト' },

  { en: THUMB_LABEL, japanese: '親指部分' },
  { en: PINKY_LABEL, japanese: '小指部分' },
  { en: LITTLE_LABEL, japanese: '小指部分' },
  { en: PINKY_SIDE_BACK_LABEL, japanese: '小指側背面' },
  { en: LEATHER_LINING_FIRST_LABEL, japanese: '裏革部分(1段目)' },
  { en: LEATHER_LINING_SECOND_LABEL, japanese: '裏革部分(2段目)' },
  { en: SANS_SERIF_LABEL, japanese: '活字体' },
  { en: CURSIVE_LABEL, japanese: '筆記体' },
  { en: CURSIVE_LABEL, japanese: '筆記体' },
  { en: SERIF_LABEL, japanese: '漢字(楷書体)' }
]
